import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { ConfluenceOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { FeatureExposed } from '@/utils/feature-exposed/use-feature-exposed';

import { GetStartedText } from '../../../components/get-started-heading';
import { Headings } from '../../../components/headings';
import { FreeForTenUsersText } from '../../../components/sub-heading';
import { InputSubmitButton } from '../../../components/submit-input';

export const LoggedOutConfluenceFree = () => {
	return (
		<div data-testid="logged-out-confluence-free">
			<FeatureExposed experimentKey="cfind-2409-v2-cobranding-signup" group="test">
				<FeatureExposed experimentKey="jfind-1192-signup-button-update-cfind" group="test">
					<FeatureExposed experimentKey="cfind-3467-signup-with-image-overlay" group="isTreatment">
						<ConfluenceOverlayTemplate size="sm">
							<Headings
								main={<GetStartedText productName="Confluence" />}
								sub={<FreeForTenUsersText />}
							/>
							<AccountCreation Input={<InputSubmitButton />} Submit={null} />
						</ConfluenceOverlayTemplate>
					</FeatureExposed>
				</FeatureExposed>
			</FeatureExposed>
		</div>
	);
};
